module.exports = __webpack_public_path__ + "img/instagram.daae5590.svg";